/* Path */
export const defaultStartPath = '/app/gogo/start';
export const searchPath = "/app/gogo/start";

/* Menu */
export const defaultMenuType = 'menu-sub-hidden';
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;